module.exports = __webpack_public_path__ + "img/national6.8fc3a1c2.png";